(function () {
    "use strict";

    angular.module("app").factory("externalDependencies", ExternalDependenciesFactory);

    /**
     * Collects external libraries we can use to decorate a controller
     */
    ExternalDependenciesFactory.$inject = ["habilBootbox"];
    function ExternalDependenciesFactory(habilBootbox) {
        return {
            Bootbox: habilBootbox,
        };
    }
})();
